import { Box, styled, TextField } from '@mui/material';

const PaperWrapper = styled(Box)(() => ({
  marginTop: 16,
  maxWidth: '100%',
  marginLeft: 'auto',
  marginRight: 'auto',
  paddingLeft: 16,
  paddingRight: 16,
  paddingTop: 32,
  paddingBottom: 32,
  backgroundColor: '#fff',
  borderRadius: 8,
  boxShadow:
    '0px 2px 4px -1px #e0e0e0, 0px 4px 5px 0px #bdbdbd, 0px 1px 10px 0px #9e9e9e',
  display: 'flex',
  flexDirection: 'row',
  gap: 8,
  boxSizing: 'border-box'
}));

const RootContainer = styled(Box)(() => ({}));

const HeaderBar = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center'
}));

const SchoolSelectField = styled(TextField)(() => ({
  minWidth: 240
}));

const DialogContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  marginTop: theme.spacing(1)
}));

const DialogRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(2),
  marginTop: theme.spacing(1)
}));

const AdminAccessSection = styled(Box)(() => ({}));

const AdminAccessOptions = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column'
}));

const AdminAccessInner = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginLeft: theme.spacing(1)
}));

const StyledTextField = styled(TextField)(() => ({
  width: '50%'
}));

const AddUserButtonWrapper = styled(Box)(() => ({ alignSelf: 'center' }));

const AdminAccessWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  marginTop: theme.spacing(1)
}));

const AdminAccessOptionsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginLeft: theme.spacing(1)
}));

const UsersTableContainer = styled(PaperWrapper)(({ theme }) => ({
  position: 'relative',
  marginTop: theme.spacing(2)
}));

const LoadingOverlay = styled(Box)(() => ({
  position: 'absolute',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'rgba(255,255,255,0.6)',
  zIndex: 1
}));

export {
  PaperWrapper,
  RootContainer,
  HeaderBar,
  SchoolSelectField,
  DialogContent,
  DialogRow,
  AdminAccessSection,
  AdminAccessOptions,
  AdminAccessInner,
  StyledTextField,
  AddUserButtonWrapper,
  AdminAccessWrapper,
  AdminAccessOptionsContainer,
  UsersTableContainer,
  LoadingOverlay
};
